export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://docs.microsoft.com/en-us/microsoft-365/security/office-365-security/preset-security-policies?view=o365-worldwide#:~:text=Preset%20security%20policies%20use%20the,the%20settings%20in%20these%20policies.';
